import { createAction } from 'redux-actions';
// Dynamic redux
export const reduxModuleLoaded = createAction('@@gruser.REDUX_READY', ()=>({}));
export const init = createAction('@@gruser.GRUSERPAGE.INIT', (payload)=>payload);
